import { forwardRef } from 'react';
import { EventOrWebinarType } from 'src/types/backendContent';
import { Form, FormBaseProps, FormForEnum } from 'src/uikit/Form';

type FormBlockProps = EventOrWebinarType;

export const FormBlock = forwardRef<HTMLDivElement, FormBlockProps>(
  (props, ref) => {
    const {
      pageType,
      title,
      content,
      eventSessionID,
      startsAt,
      status,
      markID,
      categories,
      format,
    } = props;

    const isEvent = pageType === 'event';

    if (
      (content?.form?.isShow !== undefined && !content?.form?.isShow) ||
      content?.ctaButton?.isRegistrationClose ||
      status === 'STOP'
    ) {
      return null;
    }

    const getFormFields = (): Partial<FormBaseProps> => {
      const commentLabel = content?.form?.commentsList
        ? content?.form?.commentsList[0]
        : undefined;
      const formTitle = content?.form?.title ? content?.form?.title : undefined;
      const formSuccessNotice = content?.form?.submitText
        ? content?.form?.submitText
        : undefined;

      const isOfflineEvent =
        categories.find((category) => category.slug !== 'webinars') &&
        format !== 'online';

      return {
        allFormsSentFormType: 'webinar', //FIXME: придумать для event отдельный type
        inputPath: isEvent ? 'v2/order' : 'v2/webinar_register',
        fieldsNames: {
          comment: {
            label:
              commentLabel ??
              (isEvent
                ? 'Вопрос по теме мероприятия'
                : 'Вопрос по теме вебинара'),
          },
        },
        title:
          formTitle ??
          (isEvent ? 'Регистрация на мероприятие' : 'Регистрация на вебинар'),
        successNotice: {
          title:
            formSuccessNotice ??
            (isEvent
              ? 'Вы зарегистрированы на мероприятие, письмо с подтверждением придет к вам на почту!'
              : 'Спасибо за регистрацию. Письмо со ссылкой на вебинар придет в день мероприятия'),
        },
        buttonTitle: content?.form?.buttonTitle
          ? content?.form?.buttonTitle
          : undefined,
        additionalFields: isEvent
          ? { subsegment: 'product_form', priority: '3', leadSource: 'event' }
          : undefined,
        webinarsFields: !isEvent
          ? {
              webinarId: Number(eventSessionID),
              webinarName: title,
              startsAt: startsAt,
            }
          : undefined,
        formFor: isOfflineEvent
          ? FormForEnum.OfflineEvent
          : FormForEnum.Default,
        successfulSubmissonFormAnalytics: {
          formname: isEvent ? 'lead-events' : 'webinar-registration',
        },
        legalEntity: pageType === 'webinar',
      };
    };

    const fields = getFormFields();

    return (
      <section>
        <Form
          ref={ref}
          id="form"
          analyticsFieldFill={{ formType: 'body' }}
          agreementName="online_event_consent"
          withLoader
          allFormsSentFormType={fields.allFormsSentFormType!}
          additionalFields={fields.additionalFields}
          inputPath={fields.inputPath!}
          fieldsNames={fields.fieldsNames}
          title={fields.title}
          successNotice={fields.successNotice}
          buttonTitle={fields.buttonTitle}
          webinarsFields={fields.webinarsFields}
          marketingEventIDs={[markID]}
          formVariant="inner"
          formFor={!isEvent ? FormForEnum.Webinars : undefined}
          successfulSubmissonFormAnalytics={
            fields.successfulSubmissonFormAnalytics
          }
          legalEntity={fields.legalEntity}
        />
      </section>
    );
  },
);
